import { tv } from 'tailwind-variants'

type DividerProps = {
	variant?: 'strong' | 'subtle'
	orientation?: 'horizontal' | 'vertical'
	className?: string
}

const dividerStyles = tv({
	base: 'border-neutral-100 text-transparent',
	variants: {
		orientation: {
			horizontal: 'h-0 w-full',
			vertical: 'w-0 h-full'
		},
		variant: {
			subtle: 'border-t-[1px]',
			strong: 'border-t-[2px]'
		}
	},
	compoundVariants: [
		{
			variant: 'strong',
			orientation: 'vertical',
			className: 'border-l-[2px] border-t-0'
		},
		{
			variant: 'subtle',
			orientation: 'vertical',
			className: 'border-l-[1px] border-t-0'
		}
	],
	defaultVariants: {
		variant: 'subtle',
		orientation: 'horizontal'
	}
})

function Divider({ variant = 'subtle', orientation = 'horizontal', className }: DividerProps) {
	return <hr aria-orientation={orientation} className={dividerStyles({ variant, orientation, className })} />
}

export { Divider }
export type { DividerProps }
